<template>
  <v-card flat>
    <v-card-text id="lineChartDiv" class="py-0" ref="lineChartDiv">
      <v-skeleton-loader v-if="!updated_chart_data || updated_chart_data.length <= 1" type="image"></v-skeleton-loader>
      <GChart
        type="AreaChart"
        v-else
        :options="chartOptions"
        :data="updated_chart_data"
        :debounce="500"
        :events="chartEvents"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AreaChartVT",
  props: {
    chartData: Array,
    ylabel: String,
    xlabel: String,
    lineWidth: String,
    pointSize: String,
    dataOpacity: String,
    colors: Array,
    vAxes: Object,
    series: Object,
    chart_title: String,
    hAxis: Object,
  },
  watch: {
    chart_title: function (newVal) {
      this.chartOptions.title = newVal;
    },
  },
  data: function () {
    return {
      chartsLib: {},
      chartOptions: {
        backgroundColor: "transparent",
        width: "100%",
        title: this.chart_title,
        csv_headers: "1",
        responsive: true,
        maintainAspectRatio: false,
        height: 300,
        chartArea: { top: 30, width: "94%" },
        legend: {
          position: "bottom",
          textStyle: {
            color: this.$vuetify.theme.dark ? "#A9A9A9" : "#a1c7e2",
            fontSize: "0.75em",
          },
          count: 3,
        },
        curveType: "function",
        lineWidth: this.lineWidth || 3,
        pointSize: this.pointSize || 3,
        dataOpacity: this.dataOpacity || 0.3,
        //tooltip: { isHtml: true },
        colors: this.colors || ["#1b428b", "#e14615", "#52a0d1"],
        vAxes: this.vAxes || {
          0: {
            title: this.ylabel,
            gridlines: { color: "#325597", count: 3 },
            minorGridlines: { color: "#fff" },
            textStyle: { color: "#a1c7e2", fontSize: 9 },
            viewWindowMode: "pretty",
            viewWindow: {
              min: 0,
            },
          },
        },
        crosshair: {
          trigger: "focus",
          orientation: "both",
        },
        series: this.series || {},
        /*vAxis: {
          title: this.ylabel,
          gridlines: { color: "#325597", count: 3 },
          minorGridlines: { color: "#fff" },
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "pretty",
          viewWindow: {
            min: 0,
            max: 500
          },
        },*/
        hAxis: this.hAxis || {
          title: this.xlabel,
          titleTextStyle: {
            color: this.$vuetify.theme.dark ? "#E0E0E0" : "#03001C",
          },
          textStyle: { color: "#a1c7e2", fontSize: 9 },
          viewWindowMode: "maximized",
        },
        animation: {
          duration: 500,
          easing: "in",
          startup: true,
        },
      },
      chartEvents: {
        error: (errorObj) => {
          if (errorObj.message == "Data column(s) for axis #0 cannot be of type string")
            window.$(`#${errorObj.id} span`)[0].innerHTML =
              "Oops, there is no data available for the selected time period.";
        },
      },
    };
  },
  methods: {
    createCustomHTMLContent(title, msg, value) {
      return `<div class='d-flex rounded custom-tooltip'>
      <div class='pl-1 rounded-l primaryOutline'></div>
      <div class='d-flex flex-column primaryDark--text px-2'>
        <div>
          ${title}
        </div>
        <div class='primaryGrey--text caption'>
          <span class='primaryDark--text font-weight-bold'>
          ${value}
        </span>${msg}
        </div>
      </div>
    </div> `;
    },
  },
  created() {
    this.page_config = this.$config;
  },
  computed: {
    msg() {
      return this.$auth.error;
    },
    updated_chart_data() {
      return this.chartData;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .custom-tooltip {
  width: 150px;
  min-height: 50px;
  max-height: 200px;
  border: none;
  box-shadow:
    -3px -1px 20px 0 rgba(0, 0, 0, 0.18),
    0 6px 20px 0 rgba(153, 155, 168, 0.1);
}
::v-deep .google-visualization-tooltip {
  border: none !important;
}
</style>
